import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
// Hook
import usePieCharts from '../../hooks/usePieCharts';

function PieChart(props) {
  const { dataTypes } = props;
  const { pieData } = usePieCharts(dataTypes);

  useEffect(() => {
    // Create chart instance
    am4core.ready(() => {
      const chart = am4core.create('chartdiv', am4charts.PieChart);
      am4core.addLicense('ch-custom-attribution');
      am4core.options.autoDispose = true;

      /* Create series */
      const series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = 'total';
      series.dataFields.category = 'name';

      /* Disable labels */
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;

      /* Create legend */
      chart.legend = new am4charts.Legend();
      chart.legend.position = 'right';
      chart.legend.scrollable = true;
      const marker = chart.legend.markers.template.children.getIndex(0);
      marker.cornerRadius(12, 12, 12, 12);

      // Add data
      chart.data = pieData;

      // Enable export
      chart.exporting.menu = new am4core.ExportMenu();

      // Cleanup chart on unmount
      return () => {
        chart.dispose();
      };
    });
  }, [pieData]);

  return (
    <div className="row charDashboard">
      <div className="col-12 col-md-12" id="chartdiv" />
    </div>
  );
}

PieChart.propTypes = {
  dataTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PieChart;
